import React from 'react'

import clsx from 'clsx'

import BreadcrumbRoot from 'components/Breadcrumb/BreadcrumbRoot'
import Icon from 'components/Icon'
import Typography from 'components/Typography'
import { getBreadCrumbStructuredData } from 'helpers/SEOHelper'
import { addEvent } from 'lib/AnalyticsGDM'

import classes from './Breadcrumb.module.scss'

/** @type {import('./types').default} */
const Breadcrumb = ({ children, className, structuredDataItems }) => {
  if (!children) {
    return <div className="Breadcrumb" />
  }

  return (
    <div className={clsx('Breadcrumb', classes.root, className)} data-testid="BreadcrumbBar">
      <BreadcrumbRoot>
        <a
          className={clsx('HomeIcon', classes.iconLink, 'evnt')}
          href="/"
          {...addEvent(
            {
              engagementDestination: 'go-to_home',
              engagementComponent: 'breadcrumb-menu',
              engagementDetails: 'navigation-tab',
              name: 'engagement_navigation',
            },
            {
              noClientSide: true,
            }
          )}
        >
          <Icon icon={['fal', 'sitemap']} />
        </a>
        {React.Children.map(children, child => child)
          .filter(breadcrumb => !breadcrumb?.props?.hidden)
          .map((child, index) => React.cloneElement(child, { position: index + 1 }))}
      </BreadcrumbRoot>
      {!!structuredDataItems?.length && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: getBreadCrumbStructuredData(structuredDataItems) }}
        />
      )}
    </div>
  )
}

const BreadcrumbItem = ({ children, href, action, isDisabled, className }) => {
  const label = (
    <Typography
      className={clsx(
        classes.label,
        {
          [classes.labelDisabled]: isDisabled,
        },
        className
      )}
      component="span"
      itemProp="name"
    >
      {children}
    </Typography>
  )

  return (
    <div className="BreadcrumbItem">
      {isDisabled ? (
        label
      ) : (
        <a
          className={clsx(classes.link, 'evnt', className)}
          href={href}
          {...addEvent(
            {
              engagementComponent: 'breadcrumb-menu',
              engagementDetails: 'navigation-tab',
              name: 'engagement_navigation',
              engagementDestination: action,
            },
            {
              noClientSide: true,
            }
          )}
        >
          {label}
        </a>
      )}
    </div>
  )
}

Breadcrumb.Item = BreadcrumbItem

export default Breadcrumb
export { BreadcrumbItem }
